module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;

	var myFormData = function () {
		var _storage = [];

		this.append = function (name, value, filename) {
			_storage.push([name, value, filename]);
		};

		this.getAll = function() {
			return _storage;
		}
	};

	fox.registerWidget('Form_Element_FileUploaderSimple', {
		configure: function(options) {
			this.registerOptions('', {
				upload: {
					method: 'ClientUploadManager.upload',
					beforeUnloadMessage: 'File upload is in progress, please wait until it\'s over',
					useFormData: true,
					widget: null,
					httpMethod: 'post',
					chunkSize: 0
				},
				info: {
					method: 'ClientUploadManager.info',
					widget: null,
					skipInfo: false,
					httpMethod: 'get'
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this.callParent('init', arguments);
			this.uploaderIndex = 0;
			this.uploaders = [];

			this.configureApis();
			this.progress = 0;
			this.inProgress = false;
			this.failed = false;
			this.apiParams = {};
			this.fileInfo = {};
			this.filesMeta = {};
			this._inProgress = [];
			this._queue = [];
			this._globalScope = window;
		},

		running: function() {
			this.switchState();

			this.callParent('running', arguments);
		},

		setFileInfo: function(info) {
			this.setValue(info.id);
			this.fileInfo = info;
			this.switchState();
		},

		setApiParams: function(params) {
			this.apiParams = params;
		},

		switchState: function() {
			if (this.failed) {
				this.state = 'failed';
			} else if (this.inProgress) {
				this.state = 'progress';
			} else if (fox.isEmpty(this.fileInfo)) {
				this.state = 'input';
			} else {
				this.state = 'exists';
			}

			this.dispatchEvent('switchState', this.state);
			return this.state;
		},

		setValue: function (val, noLog) {
			if (typeof val === 'undefined') {
				val = '';
			}

			this._setValue(val);
			this.value = val;
			this.dispatchEvent('valueChanged', this);
			this.dispatchEvent('changed', this);

			if (this.getOption('autoApply')) {
				this.form._setValue(this.getAlias(), val, noLog);
			}

			var params = this.getOption('info.apiParams') || {};
			params.id = val;

			if (!fox.isEmpty(val) && !this.getOption('info.skipInfo') && this.fileInfo.id != val && this.wom1('#info')) {
				this.__infoPromise = this.rwom1('#info').psend(params).then(function (resp) {
					this.__infoPromise = null;

					return fox.objectGet(resp, 'params.answer.response') || {info: {}};
				}.bind(this)).catch(function (err) {
					this.__infoPromise = null;

					throw err;
				}.bind(this));
			}

			if (!val) {
				this.resetValue();
			}

			return this;
		},

		_setValue: function (val) {
			return true;
		},

		resetValue: function() {
			this.setValue(this.emptyValue);
			this.fileInfo = {};
			this.switchState();
		},

		changeHandler: function(elt, alias, scope, e) {
			if (this.callParent('changeHandler', arguments)) {

				if (this._checkWinIe()) this._globalScope = elt.ownerDocument.defaultView;

				this.hookWrapper('initUpload', elt.files);

				if (this.getOption('autoSubmit')) {
					this.form.autoSubmit = true;
				}

				return true;
			}

			return false;
		},

		_checkWinIe: function () {
			var ua = navigator.userAgent;

			var isWindows = navigator.platform === 'Win32';
			var isEdge = /Edge/.test(ua);
			var isIe = /(MSIE|Trident)/.test(ua);

			return isWindows && (isEdge || isIe);
		},

		_checkFileInstance: function (file) {
			if ('__fakeFile' in file)
				return file.__fakeFile;

			return file instanceof this._globalScope.Blob;
		},

		eachFiles: function (files, callback, thisArg) {
			if (!fox.isFunction(callback)) return false;

			if ('length' in files && fox.isFunction(files.item)) {
				var length = files.length;

				for (var i = 0; i < length; i++) {
					callback.call(thisArg || null, files.item(i), i);
				}

				return true;
			}
			
			return fox.each.apply(fox, arguments);
		},

		_initUploadOneApi: function (files, params) {
			var args = fox.clone(arguments);
			var uploader = this.getUploader(0);
			var id = uploader.getId();
			var formData = new myFormData();

			this.failed = false;
			this.filesMeta[id] = [];

			this.eachFiles(files, function (file) {
				if (fox.isObject(file) && file.file) {
					file = file.file;
				}

				if (!this._checkFileInstance(file))
					return false;

				formData.append('file[]', file, file.name);
				this.filesMeta[id].push(file);
			}, this);

			if (!uploader.getOption('skipUploadParams')) {
				fox.each(params, function(val, key) {
					formData.append(key, val);
				});

				fox.each(this.getOption('upload.apiParams'), function(val, key) {
					formData.append(key, val);
				});
			}

			this.sentParams = uploader.sentParams = params;

			return uploader.psend(formData.getAll()).catch(function () {
				return new Promise(function (resolve) {
					this._reupload = function () {
						return this._initUploadOneApi.apply(this, args).then(resolve);
					};
				}.bind(this));
			}.bind(this)).then(function (resp) {
				delete this._reupload;

				return resp;
			}.bind(this));
		},

		_initUploadMultipleApi: function(files, params) {
			var sendFile;
			var sendPromises = [];
			var maxSameTimeUploads = this.getOption('maxSameTimeUploads') || 0;

			sendFile = function (file, _params) {
				var chunkSize = this.getOption('upload.chunkSize');
				var formData = chunkSize ? new xFormData() : new myFormData();

				function _release () {
					this._inProgress.pop();

					var queue = this._queue.pop();

					if (queue) this.dispatchEvent('queue_release_' + queue[0].getId(), queue);
					if (this.getOption('cleanUploaders')) this.destroyUploader(uploader);
				}

				function _send (uploader, data) {
					var id = uploader.getId();

					if (this._inProgress.indexOf(id) === -1) {
						this._inProgress.push(id);
					}

					return uploader.psend(data).then(function (resp) {
						_release.call(this);

						return resp;
					}.bind(this)).catch(function (e) {
						var maxReuploadAmount = this.getOption('maxReuploadAmount') || 0;

						if (!('reupload' in uploader)) uploader.reupload = 0;

						if (e.event === 'error' &&
							maxReuploadAmount > 0 &&
							uploader.reupload < maxReuploadAmount) {
							this.failed = false;
							uploader.reupload++;

							if (__DEV__) {
								console.log('Reuploading with uploaderId: ' + id);
							}

							return _send.call(this, uploader, data);
						}

						_release.call(this);
					}.bind(this));
				}

				if (chunkSize) {
					formData.setFileChunkSize(chunkSize);
				}

				formData[chunkSize ? 'appendFile' : 'append']('file', file, file.name);

				var uploader = this.getUploader();

				if (!uploader.getOption('skipUploadParams')) {
					fox.each(_params, function(val, key) {
						formData[chunkSize ? 'appendValue' : 'append'](key, val);
					});
					fox.each(this.getOption('upload.apiParams'), function(val, key) {
						formData[chunkSize ? 'appendValue' : 'append'](key, val);
					});
				}

				this.addFileMeta(uploader.getId(), file);
				uploader.sentParams = _params;
				this.sentParams = _params;

				if (maxSameTimeUploads > 0 && this._inProgress.length === maxSameTimeUploads) {
					this._queue.unshift([uploader, formData.getAll()]);

					uploader.dispatchEvent('loadstart');

					return this.wait('queue_release_' + uploader.getId()).then(function (resp) {
						return _send.apply(this, resp.params);
					}.bind(this));
				}

				return _send.call(this, uploader, formData.getAll());
			};

			this.failed = false;

			this.eachFiles(files, function (file) {
				if (this._checkFileInstance(file)) {
					sendPromises.push(sendFile.call(this, file, params));
				} else if (fox.isObject(file) && this._checkFileInstance(file.file)) {
					sendPromises.push(sendFile.call(this, file.file, file.params || params || {}));
				}
			}, this);

			this.clearFileElement();

			return fox.RSVP.all(sendPromises);
		},

		destroyUploader: function (uploader) {
			this.uploaders = fox.without(this.uploaders, uploader);
			this.uploaderIndex = this.uploaders.length;

			uploader.destroy();
		},

		initUpload: function () {
			return this.getOption('useOneApi') &&
				this._initUploadOneApi.apply(this, arguments) ||
				this._initUploadMultipleApi.apply(this, arguments);
		},

		addFileMeta: function (id, fileMeta) {
			if (!this.filesMeta.hasOwnProperty(id)) this.filesMeta[id] = fileMeta;

			return this;
		},

		removeFileMeta: function (id) {
			return this.filesMeta.hasOwnProperty(id) && delete this.filesMeta[id];
		},

		getUploader: function() {
			var index = this.uploaderIndex++;

			if (!this.uploaders[index]) {
				this._createUploader(index);
			}

			return this.uploaders[index];
		},

		_createUploader: function(index) {
			var
				props = this.getOption('upload'),
				name = 'upload' + (index === 0 ? '' : index),
				uploader
			;

			if (props.widget) {
				if (fox.wom.isSelector(props.widget)) {
					uploader = fox.wom.selectFirst(props.widget);
				} else {
					uploader = props.widget;
				}
			}

			if (!uploader || fox.isString(uploader)) {
				this.embedWidget(name, uploader || 'Api', props);
				this.embedWidgetsFromOptions();
				this.uploaders[index] = this.rwom1('#' + name);
			} else {
				this.uploaders[index] = uploader;
			}

			if (!this.uploaders[index].isRun()) {
				this.uploaders[index].run();
			}

			return this._createListeners(this.uploaders[index]);
		},

		_createListeners: function (uploader) {
			this.handleEvent(uploader, 'loadstart', fox.bind(function(data) {
				this.inProgress = true;
				this.switchState();
				this.dispatchEvent('loadstart', data);
			}, this), {listenHistory: true});

			this.handleEvent(uploader, 'loadend', fox.bind(function(data) {
				this.inProgress = false;
				this.dispatchEvent('loadend', data);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'progress', fox.bind(function(data) {
				if (!this.inProgress) {
					if (uploader.aborted) return delete uploader.aborted;

					uploader.dispatchEvent('loadstart');
					this.dispatchEvent('loadstart', {});
					this.inProgress = true;
				}
				this.dispatchEvent('progress', data);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'ready', fox.bind(function(response) {
				this.setFileInfo(response);
				this.dispatchEvent('ready', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'error', fox.bind(function(response) {
				this.failed = true;
				this.switchState();
				this.dispatchEvent('error', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'failure', fox.bind(function(response) {
				this.failed = true;
				this.switchState();
				this.dispatchEvent('failure', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'abort', function (response) {
				uploader.aborted = true;
				this.inProgress = false;
				this.switchState();
			}.bind(this), {alwaysActive: true});
		},

		unloadNotice: function() {
			return this.getOption('unloadNotice');
		},

		configureApis: function() {
			if (!this.info) {
				var props = this.getOption('info');

				if (!props) {
					return;
				}

				if (props.widget) {
					if (fox.wom.isSelector(props.widget)) {
						this.info = fox.wom.selectFirst(props.widget);
					} else {
						this.info = props.widget;
					}
				}

				this.embedWidget('info', 'Api', props);
				this.embedWidgetsFromOptions();
				this.info = this.rwom1('#info');
			}

			this.handleEvent(this.info, 'ready', function(response) {
				this.setFileInfo(response);
			});
		}

	}, 'Form_Element_FileUploaderInterface');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/fileuploadersimple.js
// module id = 193
// module chunks = 0